import axios from "axios";
import { API_BASEURL } from "../api";
import { CreatePricingDetailT } from "./pricing.types";

export const sendPricingDetailsApi = async (data: CreatePricingDetailT) => {
  return await axios.post(`${API_BASEURL}/pricing/send-product-price`, data);
};
